// We haven't added icon's computed property because it makes this mixin coupled with UI
export const togglePasswordVisibility = {
  data() {
    return {
      passwordFieldType: 'password',
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
  },
}
export const togglePasswordVisibility1 = {
  data() {
    return {
      passwordFieldType1: 'password',
    }
  },
  methods: {
    togglePasswordVisibility1() {
      this.passwordFieldType1 = this.passwordFieldType1 === 'password' ? 'text' : 'password'
    },
  },
}

export const togglePasswordVisibility2 = {
  data() {
    return {
      passwordFieldType2: 'password',
    }
  },
  methods: {
    togglePasswordVisibility2() {
      this.passwordFieldType2 = this.passwordFieldType2 === 'password' ? 'text' : 'password'
    },
  },
}


export const _ = null
